(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/collections/betslip-matchlist.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/collections/betslip-matchlist.js'); svs.tipset.collections.BetslipMatchlist = Backbone.Collection.extend({
  model: svs.tipset.models.BetslipMatch,

  initialize: function() {
    this.listenTo(
      svs.tipset.collections.matchlist,
      'buttonBet resetAll',
      this.updateMatchList
    );
    this.listenTo(
      svs.tipset.collections.matchlist,
      'updateWeights',
      this.updateMatchList
    );
    this.setMatchList();
  },

  setMatchList: function() {
    var self = this,
      matches = svs.tipset.collections.matchlist.getAllMatches();
    _.each(matches, function(match) {
      var newMatch = new svs.tipset.models.BetslipMatch();
      newMatch.setData(
        match.get('marks'),
        match.get('eventDescription'),
        match.get('h2hDescription'),
        match.get('eventNumber'),
        match.get('weights')
      );
      self.add(newMatch, { merge: true });
    });
  },

  updateMatchList: function() {
    var matches = svs.tipset.collections.matchlist.getAllMatches();
    this.each(function(match, index) {
      match.setData(
        matches[index].get('marks'),
        matches[index].get('eventDescription'),
        matches[index].get('h2hDescription'),
        matches[index].get('eventNumber'),
        matches[index].get('weights')
      );
    });
  }
});

 })(window);